<template lang="html">
    <div class="theme-editor">
        <div class="theme-tools p-2">
            <div class="color-option">
                <label>{{ $t("utilities.themeEditor.mainColor") }}</label>
                <input type="color" class="form-control" name="mainColor" v-model="theme.mainColor">
                <b-button-group>
                    <b-button variant="dark"
                        :class="{ 'active': theme.mainColorText == '#ffffff' }"
                        @click="theme.mainColorText = '#ffffff'">
                        <font-awesome-icon icon="font"/>
                    </b-button>
                    <b-button variant="light"
                        :class="{ 'active': theme.mainColorText == '#000000' }"
                        @click="theme.mainColorText = '#000000'">
                        <font-awesome-icon icon="font" />
                    </b-button>
                </b-button-group>
                <p class="example-text" :style="{ 'backgroundColor': theme.mainColor, 'color': theme.mainColorText }">
                    The quick brown fox jumps over the lazy dog.
                </p>
            </div>
            <hr>
            <div class="color-option">
                <label>{{ $t("utilities.themeEditor.highlightColor") }}</label>
                <input type="color" class="form-control" name="highlightColor" v-model="theme.highlightColor">
                <b-button-group>
                    <b-button variant="dark"
                        :class="{ 'active': theme.highlightColorText == '#ffffff' }"
                        @click="theme.highlightColorText = '#ffffff'">
                        <font-awesome-icon icon="font"/>
                    </b-button>
                    <b-button variant="light"
                        :class="{ 'active': theme.highlightColorText == '#000000' }"
                        @click="theme.highlightColorText = '#000000'">
                        <font-awesome-icon icon="font" />
                    </b-button>
                </b-button-group>
                <p class="example-text" :style="{ 'backgroundColor': theme.highlightColor, 'color': theme.highlightColorText }">
                    The quick brown fox jumps over the lazy dog.
                </p>
            </div>
            <hr>
            <div class="banner-options">
                <label>{{ $t("utilities.themeEditor.bannerText") }}</label>
                <b-button-group>
                    <b-button variant="light"
                        :class="{ 'active': theme.bannerTextAlign == 'banner-align-left' }"
                        @click="theme.bannerTextAlign = 'banner-align-left'">
                        <font-awesome-icon icon="align-left"/>
                    </b-button>
                    <b-button variant="light"
                        :class="{ 'active': theme.bannerTextAlign == 'banner-align-center' }"
                        @click="theme.bannerTextAlign = 'banner-align-center'">
                        <font-awesome-icon icon="align-center" />
                    </b-button>
                    <b-button variant="light"
                        :class="{ 'active': theme.bannerTextAlign == 'banner-align-right' }"
                        @click="theme.bannerTextAlign = 'banner-align-right'">
                        <font-awesome-icon icon="align-right" />
                    </b-button>
                </b-button-group>
                <b-button-group>
                    <b-button variant="light"
                        :class="{ 'active': theme.bannerBgType == 'banner-bg-none' }"
                        @click="theme.bannerBgType = 'banner-bg-none'">
                        <font-awesome-icon icon="square" style="opacity:0;"/>
                    </b-button>
                    <b-button variant="light"
                        :class="{ 'active': theme.bannerBgType == 'banner-bg-faded' }"
                        @click="theme.bannerBgType = 'banner-bg-faded'">
                        <font-awesome-icon icon="square" style="opacity:0.5;"/>
                    </b-button>
                    <b-button variant="light"
                        :class="{ 'active': theme.bannerBgType == 'banner-bg-solid' }"
                        @click="theme.bannerBgType = 'banner-bg-solid'">
                        <font-awesome-icon icon="square" />
                    </b-button>
                </b-button-group>
            </div>
        </div>
        <div class="preview p-2">
            <div class="site">
                <div class="content-block p-2 logo-area"
                    :style="{
                        backgroundColor:theme.mainColor,
                        backgroundImage: 'url(' + logoPreviewSrc + ')'
                    }">
                </div>
                <div class="offer-valid-banner" :style="{backgroundColor:theme.highlightColor}"></div>
                <div class="content-block p-3 banner-area" :class="{
                    'text-left': theme.bannerTextAlign === 'banner-align-left',
                    'text-center': theme.bannerTextAlign === 'banner-align-center',
                    'text-right': theme.bannerTextAlign === 'banner-align-right'
                }" :style="{backgroundImage: 'url(' + bannerPreviewSrc + ')'}">
                    <p class="banner-text" :class="{
                        'bg-none': theme.bannerBgType === 'banner-bg-none',
                        'bg-faded': theme.bannerBgType === 'banner-bg-faded',
                        'bg-solid': theme.bannerBgType === 'banner-bg-solid'
                    }">Lorem ipsum</p>
                </div>
                <div class="content-block p-1 product-area">
                    <div class="product-details p-4 mr-1"
                        :style="{backgroundImage: 'url(' + productPreviewSrc + ')'}"
                    ></div>
                    <div class="product-rows">
                        <div class="product-row p-2 mb-1"></div>
                        <div class="product-row p-2 mb-1"></div>
                    </div>
                </div>
                <div class="content-block p-1" :style="{backgroundColor:theme.mainColor}"></div>
                <div class="content-block p-1 contact-area">
                    <div class="pdf-button p-1"></div>
                    <div class="tab-buttons">
                        <div class="tab-button p-1"></div>
                        <div class="tab-button p-1"></div>
                        <div class="tab-button p-1"></div>
                    </div>
                    <div class="content-block">
                        <div class="signature my-1 mx-auto p-2"></div>
                        <div class="accept-button mx-auto p-1" :style="{backgroundColor:theme.highlightColor}"></div>
                    </div>
                </div>
                <div class="content-block p-1 sales-area">
                    <div class="sales-box p-3 my-1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ThemeEditor',
  data () {
    return {
      hasChanges: false
    }
  },
  props: {
    theme: Object,
    images: Object
  },
  computed: {
    logoPreviewSrc () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.images.logo
    },
    bannerPreviewSrc () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.images.banner
    },
    productPreviewSrc () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.images.product
    }
  }
}
</script>

<style lang="scss">
$borderColor: #dee2e6;

.theme-editor {
    display: flex;
    flex-wrap: wrap;

    .theme-tools {
        width: 70%;

        border: 2px solid $borderColor;
        border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;

        .color-option {
            display: flex;
            flex-wrap: wrap;

            label {
                width: 100%;
            }
            input[type="color"] {
                width: 20%;
            }
            .btn-group {
                width: 20%;
                padding: 0 10px;
            }
            p.example-text {
                width: 60%;
                text-align: center;
                border-radius: 5px;
            }
        }
        .banner-options {
            display: flex;
            flex-wrap: wrap;

            label {
                width: 100%;
            }
            .btn-group {
                width: 20%;
                padding: 0 10px;
            }
        }

        .btn-group {
            > button {
                &.active, &:focus {
                    box-shadow: 0 0 0 .2rem rgba(52,58,64,.5) !important;

                    &.btn-light {
                        background-color: white !important;
                    }
                }
            }
        }
    }
    .preview {
        width: 30%;
        display: flex;
        flex-wrap: wrap;

        border: 2px solid $borderColor;
        border-left: none;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;

        .site {
            width: 100%;
            overflow: hidden;
            position: relative;
            border: 1px solid #ced4da;

            .content-block {
                width: 100%;

                &.logo-area {
                    background-size: contain;
                    background-repeat: no-repeat;
                }
                &.banner-area {
                    background-size: cover;
                    background-repeat: no-repeat;
                    // background-position: center center;

                    .banner-text {
                        display: inline-block;
                        padding: 5px;
                        // color: transparent;
                        // text-shadow: 0px 0 4px rgba(0,0,0,0.9);

                        &.bg-none {
                            background-color: rgba(255,255,255,0);
                        }
                        &.bg-faded {
                            background-color: rgba(255,255,255,0.5);
                        }
                        &.bg-solid {
                            background-color: rgba(255,255,255,1);
                        }
                    }
                }
                &.product-area {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    background-color: #ededed;

                    .product-details {
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-color: white;
                        width: 30%;
                    }
                    .product-rows {
                        width: 30%;

                        .product-row {
                            width: 100%;
                            background-color: white;
                        }
                    }
                }
                &.contact-area {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;

                    .tab-buttons {
                        display: flex;
                        width: 60%;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        .tab-button {
                            background-color: #ededed;
                            width: 30%;
                        }
                    }
                    .signature {
                        width: 40%;
                        border: 1px solid #cbc9c6;
                    }
                    .accept-button {
                        width: 40%;
                    }
                }
                &.sales-area {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;

                    .sales-box {
                        background-color: #ededed;
                        width: 60%;
                    }
                }
            }
            .offer-valid-banner {
                right: -25em !important;
                padding: 10px !important;
            }
        }
    }
}
</style>
